import { path } from 'app/utils/path';

export function viewUrl(moduleName: string): string | null {
  switch (moduleName) {
    case 'HASHTAGS': {
      return path.hashtags.HASHTAG_VIEW_URI;
    }
    case 'ORGANIZATIONS': {
      return path.organization.ORGANIZATION_DETAILS_URI;
    }
    case 'SETS': {
      return path.sets.SETS_WORDS_URI;
    }
    case 'VIDEOS': {
      return path.posts.YOUTUBE_POST_DETAILS_URI;
    }
    case 'INFLUENCERS': {
      return path.influencers.ANALYZED_INFLUENCER_DETAILS_URI;
    }
    case 'ENTITIES': {
      return path.entities.ANALYZED_ENTITIES_DETAILS_URI;
    }
    case 'NEWS': {
      return path.news.NEWS_DETAILS_URI;
    }
    case 'AUTHORS': {
      return path.news.AUTHOR_DETAILS_URI;
    }
    case 'EDITIORS': {
      return path.news.EDITOR_DETAILS_URI;
    }
    case 'USERS': {
      return path.users.USER_PROFILE_URI;
    }
    case 'SOURCES': {
      return path.news.SOURCE_DETAILS_URI;
    }
    case 'SOURCE_EDITIONS': {
      return path.news.SOURCE_EDITIONS_DETAILS_URI;
    }
    case 'TOPICS': {
      return path.topics.TOPICS_DETAILS_URI;
    }
    case 'ARCHIVE': {
      return path.archive.ARCHIVE_DETAILS_URI;
    }
    case 'INSTAGRAM': {
      return path.posts.INSTAGRAM_POSTS_DETAILS_URI;
    }
    case 'TIKTOK': {
      return path.posts.TIKTOK_POST_DETAILS_URI;
    }
    case 'YOUTUBE': {
      return path.posts.YOUTUBE_POST_DETAILS_URI;
    }
    case 'TWITTER': {
      return path.posts.TWITTER_POST_DETAILS_URI;
    }
    case 'LINKEDIN': {
      return path.posts.LINKEDIN_POST_DETAILS_URI;
    }
    //temp solution
    case 'TEMPLATES': {
      return path.reports.TEMPLATE_DETAILS_URI + `/${moduleName}`;
    }
    default: {
      return null;
    }
  }
}

export const openInNewTab = (url: string): void => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
